
define(['utils', 'valForm', 'jqMess', 'recaptcha'], function(utils){

	var $FormContact		= utils.getDomElement('contactForm');
	utils.checkMaterialForm($FormContact);

	$FormContact.valForm([
		{	'id'			: 'contact_objet',
			'mess'			: utils.translate('contact_error_objet')},

		{	'id'			: 'contact_lastname',
			'reg'			: '(.){2,}',
			'mess'			: utils.translate('contact_error_lastname')},

		{	'id'			: 'contact_firstname',
			'reg'			: '(.){2,}',
			'mess'			: utils.translate('contact_error_firstname')},

		{	'id'			: 'contact_email',
			'reg'			: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$",
			'mess'			: utils.translate('contact_error_email')},

		{	'id'			: 'contact_comment',
			'reg'			: '(.){2,}',
			'mess'			: utils.translate('contact_error_message')}
	],	{
		callback			: checkCaptcha
	});


	function checkCaptcha(valid) {

		if(!valid) {
			$.jqMess({message: utils.translate('global_valid_allfields'), classname : 'error', delay: 5000, color:'#660000'});
			return;
		}

		utils.loading(true);
		refreshCaptchaToken();
	}

	function refreshCaptchaToken() {

		grecaptcha.ready(function() {
			grecaptcha.execute(recaptchaPublicKey, {action: 'contact'}).then(function(token) {
				utils.getDomElement('contact_recaptcha').val(token);
				$FormContact.unbind('submit').submit();
			});
		});
	}
});